import React from 'react'
import clsx from 'clsx'
import { FormControlLabel, Radio } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { RadioGroupFormsy } from '@fuse/components/formsy'
import { PlanBillingPaymentMethodCard } from './PlanBillingPaymentMethod'
import * as R from 'ramda'

const useStyles = makeStyles((theme) => ({
  addButton: {
    color: theme.palette.secondary.main,
    'margin-right': 'auto',
  },
  paymentMethod: {
    border: `1px solid lightgrey`,
    'border-bottom': 'none',
    '&:first-child': {
      'border-radius': '5px 5px  0 0',
    },
    '&:last-child': {
      'border-radius': '0 0 5px 5px',
      'border-bottom': '1px solid lightgrey',
    },
    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
  },
  container: {
    '& fieldset.MuiFormControl-root': {
      width: '100%',
    },
  },
}))
export default function PlanBillingRechargePaymentMethodForm({
  initialValue,
  onClick,
  onDelete,
  paymentMethods,
  formState,
}) {
  const isSelectedPaymentMethod = R.propEq('default', true)
  const classes = useStyles()
  const selectedPaymentMethod = paymentMethods.find(
    (payment) => payment.default,
  )
  return (
    <RadioGroupFormsy
      className={clsx(classes.container, 'flex flex-row mt-16')}
      name="rechargePaymentMethod"
      value={R.prop('token', selectedPaymentMethod)}
    >
      {paymentMethods.map((paymentMethod) => {
        return (
          <FormControlLabel
            key={paymentMethod.token}
            value={paymentMethod.token}
            control={<Radio />}
            className={clsx(
              'cursor-pointer py-8 m-0 px-16',
              classes.paymentMethod,
              {
                [classes.selectedPaymentMethod]:
                  isSelectedPaymentMethod(paymentMethod),
                'pointer-events-none': R.prop('isSubmitting', formState),
              },
            )}
            label={
              <PlanBillingPaymentMethodCard
                className="w-full"
                isDefault={paymentMethod.default}
                onClick={onClick}
                onDelete={onDelete}
                paymentMethod={paymentMethod}
              />
            }
          />
        )
      })}
    </RadioGroupFormsy>
  )
}
